import React from 'react';
import { DragLayer } from 'react-dnd';
import GEMModalDraggingItem from 'main/components/show/cuesheet.globalElement/draggingItem.jsx';

const collect = (monitor) => {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
  };
};

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform,
  };
}

/**
 * Custom drag layer
 */
const CustomDragLayer = React.createClass({
  _renderItem(type, item) {
    switch (type) {
      case 'GEMItem': {
        return (
          <GEMModalDraggingItem row={item.row} showGlobey={item.showGlobey} />
        );
      }
      case 'FSObject': {
        let dragCount = 0;
        if (item.selectedItemIds) dragCount = item.selectedItemIds.size;
        return <FSObjectDragLayer item={item.item} dragCount={dragCount} />;
      }
      default: {
        return null;
      }
    }
  },

  render() {
    const { item, itemType, isDragging } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div className="draglayer">
        <div style={getItemStyles(this.props)}>
          {this._renderItem(itemType, item)}
        </div>
      </div>
    );
  },
});

/* eslint-disable react/prop-types */
const FSObjectDragLayer = ({ item, dragCount }) => {
  let dragCountNode = null;

  if (dragCount && dragCount > 1) {
    dragCountNode = <span>(+{dragCount - 1} more)</span>;
  }

  return (
    <div className="draglayer-fsobject">
      {item.get('name')} {dragCountNode}
    </div>
  );
};

export default DragLayer(collect)(CustomDragLayer);
/* eslint-enable react/prop-types */
